import { DesignedRainEvent, DesignedRainEvents } from "../types/designedRainEvents";

// This script contains the design regenbuien for the Netherlands
// It is based on the following python script that contains the data for these design regenbuien:
// https://github.com/nens/threedi/blob/master/lib/python-flow/python_flow/constants.py
// The values for these design regenbuien were in mm/300seconds, but the threedi-api expects them in meter/second. The values they are thus converted.
// The total is deleberately not converted, because that is what will be displayed to the user. The total is the sum of all values together.
// The values are in a format that specifies the rain intensity in meter/seconds for the current time untill the next time.
// For example:
/*
[
  [0, 0.001],
  [300, 0.002],
  [600, 0.004],
  [900, 0],
]
//*/
// This data shows rain of 0.001 meter/second for the first 300 seconds.
// Note that for the last timestep, that there is no next timestep and therefore the rain should be 0 meter/second.

// helper function to convert mm/300s to m/s
export const convertRainValues = (value: number) => {
  // input value is in mm/300s
  // convert to m/s
  return value / 300 / 1000;
};

export const designedRainsData: DesignedRainEvents = {
  "3": {
    duration: 4500,
    total: 14.4,
    values: [
      [0, convertRainValues(0.3)],
      [300, convertRainValues(0.6)],
      [600, convertRainValues(0.9)],
      [900, convertRainValues(1.5)],
      [1200, convertRainValues(2.1)],
      [1500, convertRainValues(2.1)],
      [1800, convertRainValues(1.5)],
      [2100, convertRainValues(1.2)],
      [2400, convertRainValues(1.05)],
      [2700, convertRainValues(0.9)],
      [3000, convertRainValues(0.75)],
      [3300, convertRainValues(0.6)],
      [3600, convertRainValues(0.45)],
      [3900, convertRainValues(0.3)],
      [4200, convertRainValues(0.15)],
      [4500, 0],
    ],
    description: "",
  },
  "4": {
    duration: 4500,
    total: 14.4,
    values: [
      [0, convertRainValues(0.15)],
      [300, convertRainValues(0.3)],
      [600, convertRainValues(0.45)],
      [900, convertRainValues(0.6)],
      [1200, convertRainValues(0.75)],
      [1500, convertRainValues(0.9)],
      [1800, convertRainValues(1.05)],
      [2100, convertRainValues(1.2)],
      [2400, convertRainValues(1.5)],
      [2700, convertRainValues(2.1)],
      [3000, convertRainValues(2.1)],
      [3300, convertRainValues(1.5)],
      [3600, convertRainValues(0.9)],
      [3900, convertRainValues(0.6)],
      [4200, convertRainValues(0.3)],
      [4500, 0],
    ],
    description: "",
  },
  "5": {
    duration: 4500,
    total: 16.8,
    values: [
      [0, convertRainValues(0.3)],
      [300, convertRainValues(0.6)],
      [600, convertRainValues(1.5)],
      [900, convertRainValues(2.7)],
      [1200, convertRainValues(2.7)],
      [1500, convertRainValues(2.1)],
      [1800, convertRainValues(1.5)],
      [2100, convertRainValues(1.2)],
      [2400, convertRainValues(1.05)],
      [2700, convertRainValues(0.9)],
      [3000, convertRainValues(0.75)],
      [3300, convertRainValues(0.6)],
      [3600, convertRainValues(0.45)],
      [3900, convertRainValues(0.3)],
      [4200, convertRainValues(0.15)],
      [4500, 0],
    ],
    description: "",
  },
  "6": {
    duration: 4500,
    total: 16.8,
    values: [
      [0, convertRainValues(0.15)],
      [300, convertRainValues(0.3)],
      [600, convertRainValues(0.45)],
      [900, convertRainValues(0.6)],
      [1200, convertRainValues(0.75)],
      [1500, convertRainValues(0.9)],
      [1800, convertRainValues(1.05)],
      [2100, convertRainValues(1.2)],
      [2400, convertRainValues(1.5)],
      [2700, convertRainValues(2.1)],
      [3000, convertRainValues(2.7)],
      [3300, convertRainValues(2.7)],
      [3600, convertRainValues(1.5)],
      [3900, convertRainValues(0.6)],
      [4200, convertRainValues(0.3)],
      [4500, 0],
    ],
    description: "",
  },
  "7": {
    duration: 3600,
    total: 19.8,
    values: [
      [0, convertRainValues(0.6)],
      [300, convertRainValues(1.2)],
      [600, convertRainValues(2.1)],
      [900, convertRainValues(3.3)],
      [1200, convertRainValues(3.3)],
      [1500, convertRainValues(2.7)],
      [1800, convertRainValues(2.1)],
      [2100, convertRainValues(1.5)],
      [2400, convertRainValues(1.2)],
      [2700, convertRainValues(0.9)],
      [3000, convertRainValues(0.6)],
      [3300, convertRainValues(0.3)],
      [3600, 0],
    ],
    description: "",
  },
  "8": {
    duration: 3600,
    total: 19.8,
    values: [
      [0, convertRainValues(0.3)],
      [300, convertRainValues(0.6)],
      [600, convertRainValues(0.9)],
      [900, convertRainValues(1.2)],
      [1200, convertRainValues(1.5)],
      [1500, convertRainValues(2.1)],
      [1800, convertRainValues(2.7)],
      [2100, convertRainValues(3.3)],
      [2400, convertRainValues(3.3)],
      [2700, convertRainValues(2.1)],
      [3000, convertRainValues(1.2)],
      [3300, convertRainValues(0.6)],
      [3600, 0],
    ],
    onceInAmountOfYears: 2,
    description:
      "Rain 8 is a design event that statistically occurs once every 2 years. The duration of this event is 60 minutes. The event has a peak at the back of 39 mm/h. (T=2.0 year, V=19.8 mm, C2100 RIONED) ",
  },
  "9": {
    duration: 3600,
    total: 29.4,
    values: [
      [0, convertRainValues(1.5)],
      [300, convertRainValues(2.7)],
      [600, convertRainValues(4.8)],
      [900, convertRainValues(4.8)],
      [1200, convertRainValues(4.2)],
      [1500, convertRainValues(3.3)],
      [1800, convertRainValues(2.7)],
      [2100, convertRainValues(2.1)],
      [2400, convertRainValues(1.5)],
      [2700, convertRainValues(0.9)],
      [3000, convertRainValues(0.6)],
      [3300, convertRainValues(0.3)],
      [3600, 0],
    ],
    onceInAmountOfYears: 5,
    description:
      "Rain 9 is a design event that statistically occurs once every 5 years. The duration of this event is 60 minutes. The event has a total volume of 29.4 mm/h. (T=5.0 year, V=29.4 mm, C2100 RIONED) ",
  },
  "10": {
    duration: 2700,
    total: 35.7,
    values: [
      [0, convertRainValues(1.8)],
      [300, convertRainValues(3.6)],
      [600, convertRainValues(6.3)],
      [900, convertRainValues(6.3)],
      [1200, convertRainValues(5.7)],
      [1500, convertRainValues(4.8)],
      [1800, convertRainValues(3.6)],
      [2100, convertRainValues(2.4)],
      [2400, convertRainValues(1.2)],
      [2700, 0],
    ],
    onceInAmountOfYears: 10,
    description:
      "Rain 10 is a design event that statistically occurs once every 10 years. The duration of this event is 45 minutes. The event has a peak at the front of 75 mm/h. (T=10.0 year, V=35.7 mm, C2100 RIONED) ",
  },
  "11": {
    duration: 3600,
    total: 70,
    values: [
      [0, convertRainValues(5.833333333)],
      [3600, 0],
    ],
    onceInAmountOfYears: 100,
    description:
      "Rain 11 is a design event that statistically occurs once every 100 years. The duration of this event is 1 hour. The event has a constant rain intensity of 70 mm/h. (T=100.0 year, V=70 mm, Standard rain event (local) from Delta Programme 2019) ",
  },
  "12": {
    duration: 3600,
    total: 90,
    values: [
      [0, convertRainValues(7.5)],
      [3600, 0],
    ],
    onceInAmountOfYears: 250,
    description:
      "Rain 12 is a design event that statistically occurs once every 250 years. The duration of this event is 1 hour. The event has a constant rain intensity of 90 mm/h. (T=250.0 year, V=90 mm, Standard rain event (local) from Delta Programme 2019) ",
  },
  "13": {
    duration: 7200,
    total: 160,
    values: [
      [0, convertRainValues(6.666666667)],
      [7200, 0],
    ],
    onceInAmountOfYears: 1000,
    description:
      "Rain 13 is a design event that statistically occurs once every 1000 years. The duration of this event is 2 hours. The event has a constant rain intensity of 80 mm/h. (T=1000.0 year, V=160 mm, Standard rain event (local) from Delta Programme 2019) ",
  },
  "14": {
    duration: 172800,
    total: 120,
    values: [
      [0, convertRainValues(0.208333333)],
      [172800, 0],
    ],
    onceInAmountOfYears: 100,
    description:
      "Rain 14 is a design event that statistically occurs once every 100 years. The duration of this event is 48 hours. The event has a constant rain intensity of 2.5 mm/h. (T=100.0 year, V=120 mm, Standard rain event (regional) from Delta Programme 2019) ",
  },
  "15": {
    duration: 172800,
    total: 130,
    values: [
      [0, convertRainValues(0.225694444)],
      [172800, 0],
    ],
    onceInAmountOfYears: 250,
    description:
      "Rain 15 is a design event that statistically occurs once every 250 years. The duration of this event is 48 hours. The event has a constant rain intensity of 2.7 mm/h. (T=250.0 year, V=130 mm, Standard rain event (regional) from Delta Programme 2019) ",
  },
  "16": {
    duration: 172800,
    total: 160,
    values: [
      [0, convertRainValues(0.277777778)],
      [172800, 0],
    ],
    onceInAmountOfYears: 1000,
    description:
      "Rain 16 is a design event that statistically occurs once every 1000 years. The duration of this event is 48 hours. The event has a constant rain intensity of 3.4 mm/h. (T=1000.0 year, V=160 mm, Standard rain event (regional) from Delta Programme 2019) ",
  },
};

// Check if a given set of values is equal to one of the design showers.
export const findDesignRain = (values: number[][]): [string, DesignedRainEvent] | [null, null] => {
  const entries = Object.entries(designedRainsData);

  for (let i = 0; i < entries.length; i++) {
    const [rain, data] = entries[i];
    let equal = true;

    if (values.length !== data.values.length) {
      equal = false;
    } else {
      for (let j = 0; j < values.length; j++) {
        if (values[j][0] !== data.values[j][0] || values[j][1] !== data.values[j][1]) {
          equal = false;
          break;
        }
      }
    }

    if (equal) return [rain, data];
  }

  return [null, null];
};
